import React from 'react';
import { Popover, Typography } from '@mui/material';
import { palette } from 'theme/palette';
import { theme } from 'theme';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { jbColors } from 'theme/jbColors';

const styles = {
  popover: {
    pointerEvents: 'none',
    '& .MuiMenu-paper': {
      padding: theme.spacing(1.5),
      borderRadius: 0,
      maxWidth: '320px',
    },
  },
  typography: {
    color: palette.black,
    inlineSize: '20rem',
    overflowWrap: 'break-word',
  },
  icon: {
    marginLeft: theme.spacing(2),
    height: '17px',
    color: jbColors.support.greenSmoke[100],
  },
};

type Props = {
  text: string;
  style?: React.CSSProperties;
};

export const IconPopover = ({ text, style }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <div
        data-testid={'popover-icon'}
        style={style}
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
      >
        <InfoOutlinedIcon id={`table-info-icon-${1}`} data-testid={`table-info-icon-${1}`} sx={styles.icon} />
      </div>
      <Popover
        id="mouse-over-popover"
        data-testid="mouse-over-popover"
        sx={styles.popover}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 100,
          horizontal: -30,
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {/* TODO - create default theme for body 1 then remove styles */}
        <Typography variant="body1" sx={styles.typography}>
          {text}
        </Typography>
      </Popover>
    </>
  );
};
